import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../../components/Hero';
import CallToAction from '../../components/CallToAction';
import '../ProjectPages/ProjectPages.css';

// Import images
import kurumHeroImage from '../../assets/images/kurum.jpg';

const CorporateSoftwareEN = () => {
  return (
    <div className="project-page corporate-software">
      <Helmet>
        <title>Software Solutions for Educational Institutions and Publishers | ProgenX 2025</title>
        <meta name="description" content="ProgenX special software solutions for educational institutions and publishers. Standards-compliant educational content, interactive learning materials, smart board applications, and corporate management systems. Digitize your education processes." />
        <meta name="keywords" content="education software, publisher solutions, smart board applications, education technology, corporate software, interactive content, educational institution software, digital education content" />
        <meta property="og:title" content="Software Solutions for Educational Institutions | ProgenX" />
        <meta property="og:description" content="Digitize education processes with special software solutions for educational institutions and publishers." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenxacademy.com/en/projects/corporate-software" />
        <link rel="canonical" href="https://progenxacademy.com/en/projects/corporate-software" />
        <link rel="alternate" hreflang="tr" href="https://progenxacademy.com/projeler/kurumsal-yazilim" />
        <link rel="alternate" hreflang="en" href="https://progenxacademy.com/en/projects/corporate-software" />
      </Helmet>

      <Hero 
        title="Software Support for Institutions and Publishers" 
        backgroundImage={kurumHeroImage}
      />

      <div className="project-content">
        <div className="container">
          <section className="project-overview">
            <h2>Special Solutions for Educational Institutions and Publishers</h2>
            <p>
              With the digital solutions we specially design for educational institutions and publishers, 
              we make education processes more efficient and effective. We use technology so that students learn better, 
              teachers teach more easily, and publishers present their content more effectively.
            </p>
          </section>

          <section className="features">
            <h2>What We Do for Educational Institutions and Publishers</h2>
            <div className="features-grid">
              <div className="feature-item">
                <h3>Standards-Compliant Educational Content</h3>
                <p>
                  We prepare your educational content in accordance with international standards. 
                  This way, your content works smoothly on every education platform. You can track students' 
                  progress and get detailed reports.
                </p>
              </div>

              <div className="feature-item">
                <h3>Interactive and Fun Learning Materials</h3>
                <p>
                  We prepare interactive content that attracts students' attention and makes learning fun. 
                  With rich media content such as video, animation, and sound, 
                  students learn better, teachers teach more easily.
                </p>
              </div>

              <div className="feature-item">
                <h3>Applications That Increase Classroom Interaction</h3>
                <p>
                  We develop special applications for smart boards. Teachers teach their lessons 
                  more effectively, students participate more actively. Classroom interaction increases, 
                  learning quality rises.
                </p>
              </div>

              <div className="feature-item">
                <h3>Corporate Management Systems</h3>
                <p>
                  We develop systems that allow you to manage student information, content, and reports from a single place. 
                  Works integrated with your existing systems and makes your work easier.
                </p>
              </div>
            </div>
          </section>

          <section className="benefits">
            <h2>What Do We Provide for Educational Institutions and Publishers?</h2>
            <div className="benefits-grid">
              <div className="benefit-item">
                <h3>More Efficient Education Processes</h3>
                <p>Thanks to digital content and automated systems, teachers do more work 
                by spending less time. Education processes accelerate, quality increases.</p>
              </div>

              <div className="benefit-item">
                <h3>Compatible with Your Existing Systems</h3>
                <p>Our new systems work smoothly with your existing systems. We make your work easier 
                without changing anything, just by adding.</p>
              </div>

              <div className="benefit-item">
                <h3>Track Learning Processes</h3>
                <p>You see which student has progressed how much, which topics they struggle with 
                through detailed reports. This way, you help students better.</p>
              </div>

              <div className="benefit-item">
                <h3>We Are Always With You</h3>
                <p>We are with you even after our systems are ready. We solve your problems, 
                update your systems, and provide support when you need it.</p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <CallToAction 
        title="Digitize Your Education Processes"
        subtitle="Get to know our special solutions for educational institutions and publishers."
        buttonText="Contact Us"
        buttonLink="/en/contact"
      />
    </div>
  );
};

export default CorporateSoftwareEN;
